

const formatDisplayName = (emailOrName) => {
  if (!emailOrName) return '';
  if (emailOrName.includes(' ')) {
    return emailOrName
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
  const namePart = emailOrName.split('@')[0];
  const parts = namePart.split('.');
  if (parts.length >= 2) {
    return `${parts[0].charAt(0).toUpperCase() + parts[0].slice(1).toLowerCase()} ${
      parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase()
    }`;
  }
  return namePart.charAt(0).toUpperCase() + namePart.slice(1).toLowerCase();
};

export const getSinglePublishEmailTemplate = ({
  managerName,
  employeeName,
  employeeEmail,
  cycleCode,
  startDate,
  endDate,
  adminEmail,
  publishedOn,
  loginLink,
  showViewButton = true               
} = {}) => {
  const formattedEmployeeName = formatDisplayName(employeeName || employeeEmail);
  const formattedManagerName = formatDisplayName(managerName);
  const formattedAdminName = formatDisplayName(adminEmail || 'Capability Index');

  // Smart login URL
  const getLoginUrl = () => {
    if (typeof window !== 'undefined') {
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        return 'http://localhost:3000/login';
      }
      return `${window.location.origin}/login`;
    }
    if (!loginLink) {
      throw new Error('loginLink is required when generating email on the server');
    }
    return loginLink;
  };

  const finalLoginUrl = loginLink ? loginLink : getLoginUrl();

  return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Your Performance Review is Ready - ${cycleCode}</title>
</head>
<body style="margin:0; padding:0; background:#f4f6f9; font-family:'Segoe UI',Roboto,'Helvetica Neue',Arial,sans-serif;">
  <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background:#f4f6f9; padding:40px 20px;">
    <tr>
      <td align="center">
        <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="600" style="max-width:600px; background:#ffffff; border-radius:16px; overflow:hidden; box-shadow:0 10px 30px rgba(0,0,0,0.08);">

          <!-- Header -->
          <tr>
            <td style="background:#4f46e5; padding:40px 30px; text-align:center;">
              <h1 style="margin:0 0 8px; color:#ffffff; font-size:28px; font-weight:700;">
                Your Performance Review is Ready
              </h1>
              <p style="margin:0; color:#e0e7ff; font-size:16px;">Cycle ${cycleCode}</p>
            </td>
          </tr>

          <!-- Body -->
          <tr>
            <td style="padding:40px 40px 32px; color:#1f2937;">
              <p style="margin:0 0 20px; font-size:17px; line-height:1.6;">
                Dear <strong>${formattedEmployeeName}</strong>,
              </p>

              <p style="margin:0 0 24px; font-size:15px; line-height:1.7; color:#374151;">
                Your manager, <strong>${formattedManagerName}</strong>, has completed and published your performance review.
              </p>

              <!-- Review Details Card -->
              <table role="presentation" width="100%" style="background:#f8fafc; border:1px solid #e2e8f0; border-radius:12px; margin:32px 0;">
                <tr>
                  <td style="padding:24px;">
                    <h3 style="margin:0 0 20px; font-size:18px; font-weight:700; color:#1e293b;">
                      Review Details
                    </h3>
                    <table role="presentation" width="100%" style="font-size:15px; color:#4b5563;">
                      <tr>
                        <td style="padding:8px 0; font-weight:600; width:40%;">Cycle Code</td>
                        <td style="padding:8px 0; text-align:right; font-weight:600;">${cycleCode}</td>
                      </tr>
                      <tr>
                        <td style="padding:8px 0; font-weight:600;">Review Period</td>
                        <td style="padding:8px 0; text-align:right;">${startDate} – ${endDate}</td>
                      </tr>
                      <tr>
                        <td style="padding:8px 0; font-weight:600;">Reviewed By</td>
                        <td style="padding:8px 0; text-align:right;">${formattedManagerName}</td>
                      </tr>
                      <tr>
                        <td style="padding:8px 0; font-weight:600;">Published On</td>
                        <td style="padding:8px 0; text-align:right;">${publishedOn || new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>

              <!-- Orange Button -->
              ${showViewButton ? `
              <!-- View My Review Button -->
              <div style="text-align: center; margin: 40px 0;">
                <a href="${finalLoginUrl}"
                   style="background-color: #4f46e5;
                          color: white;
                          padding: 16px 48px;
                          font-size: 17px;
                          font-weight: 700;
                          text-decoration: none;
                          border-radius: 50px;
                          display: inline-block;
                          box-shadow: 0 8px 25px rgba(6, 61, 138, 0.4);
                          transition: all 0.3s ease;">
                  View My Review
                </a>
              </div>
` : ''}

              <p style="margin:32px 0 0; font-size:14px; color:#6b7280;">
                If you have any questions about your review or need to discuss the feedback, please reach out to your manager directly.
              </p>
              <p style="margin:28px 0 0; font-size:15px; color:#374151;">
               Thank you for your continued dedication and contribution.<br>
                <strong style="color:#4f46e5;">Capability Index Team</strong>
              </p>
            </td>
          </tr>

          <!-- Footer -->
          <tr>
           <td style="background:#f9fafb; padding:32px 40px; text-align:center; border-top:1px solid #e5e7eb;">
              <p style="margin:0 0 8px; color:#9ca3af; font-size:13px; line-height:1.6;">
                This is an automated notification from the Capability Index System.
              </p>
              <p style="margin:0; color:#9ca3af; font-size:13px;">
                © 2025 Critical River. All rights reserved.
              </p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
  `.trim();
};